import { createReducer } from '../../store.model';

import {
    ActionType,
    KpiSetReloadAction,
    KpiSetReloadResultAction,
} from './kpi-set.observation.action';
import { defaultState, KpiSetState } from './kpi-set.observation.state';

const { builder, reducer } = createReducer<ActionType, KpiSetState>(
    defaultState(),
);

builder
    .add<KpiSetReloadAction>(
        ActionType.COACHING_KPI_SET__RELOAD,
        (state, action) => {
            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: true,
                },
            };
        },
    )
    .add<KpiSetReloadResultAction>(
        ActionType.COACHING_KPI_SET__RELOAD_RESULT,
        (state, action) => {
            action.payload.gridRows.sort((a, b) => {
                return a.cells[0].ctx.metric.name.localeCompare(
                    b.cells[0].ctx.metric.name,
                );
            });

            const activeGoals = action.payload.metrics
                ? action.payload.metrics
                      .filter((e) => e.isActiveGoal)
                      .map((e) => e.metricId)
                : [];
            // eslint-disable-next-line @typescript-eslint/prefer-includes
            const activeGoalRows = action.payload.gridRows.filter(
                // eslint-disable-next-line @typescript-eslint/prefer-includes
                (e) => activeGoals.indexOf(e.cells[0].ctx.metric.id) !== -1,
            );

            const focusMetrics = action.payload.metrics
                ? action.payload.metrics
                      .filter((e) => !e.isActiveGoal)
                      .map((e) => e.metricId)
                : [];
            // eslint-disable-next-line @typescript-eslint/prefer-includes
            const focusMetricRows = action.payload.gridRows.filter(
                // eslint-disable-next-line @typescript-eslint/prefer-includes
                (e) => focusMetrics.indexOf(e.cells[0].ctx.metric.id) !== -1,
            );

            return {
                ...state,
                pending: {
                    ...state.pending,
                    reload: false,
                },
                gridColumns: action.payload.gridColumns,
                gridRows: action.payload.gridRows,
                activeGoalRows,
                focusMetricRows,
            };
        },
    );

export default {
    kpiSet: reducer,
};
